module.exports = __webpack_public_path__ + "assets/img/4.6e34398a.jpg";